var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49978 7.53984L2.31845 8.91573C2.22208 8.97994 2.12134 9.00745 2.01622 8.99828C1.91109 8.98911 1.81911 8.95242 1.74027 8.88821C1.66142 8.824 1.6001 8.74365 1.5563 8.64715C1.5125 8.55066 1.50374 8.44297 1.53002 8.3241L2.1082 5.72368L0.176543 3.9763C0.0889399 3.89375 0.0342753 3.79964 0.0125496 3.69397C-0.00917605 3.5883 -0.00269342 3.48521 0.0319976 3.38467C0.067039 3.28378 0.119601 3.20122 0.189684 3.13702C0.259767 3.07281 0.35613 3.03153 0.478775 3.01319L3.02804 2.77929L4.01358 0.330212C4.05738 0.220142 4.12536 0.137588 4.21752 0.0825531C4.30968 0.0275177 4.40376 0 4.49978 0C4.59614 0 4.69023 0.0275177 4.78203 0.0825531C4.87384 0.137588 4.94182 0.220142 4.98598 0.330212L5.97152 2.77929L8.52078 3.01319C8.64342 3.03153 8.73979 3.07281 8.80987 3.13702C8.87995 3.20122 8.93251 3.28378 8.96755 3.38467C9.0026 3.48557 9.00925 3.58886 8.98753 3.69452C8.9658 3.80019 8.91096 3.89412 8.82301 3.9763L6.89135 5.72368L7.46953 8.3241C7.49582 8.44334 7.48706 8.55121 7.44325 8.64771C7.39945 8.7442 7.33813 8.82437 7.25929 8.88821C7.18044 8.95242 7.08846 8.98911 6.98334 8.99828C6.87821 9.00745 6.77747 8.97994 6.6811 8.91573L4.49978 7.53984Z",
    fill: "#FFC23E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmStar);
export default __webpack_public_path__ + "static/media/smStar.b83029932eee5a9c9f5fee9474523780.svg";
export { ForwardRef as ReactComponent };